module.exports = __webpack_public_path__ + "img/n-logo.3b14e9b0.png";